<template>
    <!-- Original file URL. Routing these through /_ipx/ waited on a resize before the first byte. -->
    <img
        v-if="src"
        :src="src"
        :alt="alt"
        :loading="eager ? 'eager' : 'lazy'"
        :fetchpriority="eager || preload ? 'high' : 'auto'"
        decoding="async"
    />
</template>

<script>
export default {
    name: 'AppImage',
    props: {
        src: {
            type: String,
            default: '',
        },
        alt: {
            type: String,
            default: '',
        },
        preset: {
            type: String,
            default: 'card',
        },
        eager: {
            type: Boolean,
            default: false,
        },
        preload: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
